import { OmisUser } from './../models/data/user.model';
import { createAction, props } from '@ngrx/store';
import { User } from '../models/data/user.model';

export const loadRoots = createAction(
  '[Root] Load Roots'
);

export const purgeAllEntities = createAction(
  '[Root] Purge Entities',
)

export const fetchEntities = createAction(
  '[Root] Fetch Entities',
  props<{
    omisUser:OmisUser
  }>()
)

export const loadCookiesAndFetchPriceList = createAction(
  '[Root] Load Cookies And Fetch PriceList',
)

export const fetchNonTokenRequireEntities = createAction(
  '[Root] Fetch Non Token Require Entities'
)



